const TYPES = {
    LOGOUT: 'LOGOUT',
    FORFEIT_FOCUS: 'FORFEIT_FOCUS',
    UPDATE_TWO_FACTOR_AUTHENTICATION: 'UPDATE_TWO_FACTOR_AUTHENTICATION',
    UPDATE_TWO_FACTOR_AUTHENTICATION_SUCCESS: 'UPDATE_TWO_FACTOR_AUTHENTICATION_SUCCESS',
    UPDATE_TWO_FACTOR_AUTHENTICATION_FAILED: 'UPDATE_TWO_FACTOR_AUTHENTICATION_FAILED',
    CHECK_EMAIL_VERIFICATION: 'CHECK_EMAIL_VERIFICATION',
    CHECK_EMAIL_VERIFICATION_SUCCESS: 'CHECK_EMAIL_VERIFICATION_SUCCESS',
    CHECK_EMAIL_VERIFICATION_FAILED: 'CHECK_EMAIL_VERIFICATION_FAILED'
};

export default {
    TYPES,

    claimFocus: componentName => ({
        type: TYPES.CLAIM_FOCUS,
        params: {componentName}
    }),

    forfeitFocus: componentName => ({
        type: TYPES.FORFEIT_FOCUS,
        params: {componentName}
    }),

    updateTwoFactorAuthentication: payload => ({
        type: TYPES.UPDATE_TWO_FACTOR_AUTHENTICATION,
        payload
    }),

    updateTwoFactorAuthenticationSuccess: payload => ({
        type: TYPES.UPDATE_TWO_FACTOR_AUTHENTICATION_SUCCESS,
        payload
    }),

    updateTwoFactorAuthenticationFailed: error => ({
        type: TYPES.UPDATE_TWO_FACTOR_AUTHENTICATION_FAILED,
        payload: {error}
    }),

    checkEmailVerification: () => ({
        type: TYPES.CHECK_EMAIL_VERIFICATION
    }),

    checkEmailVerificationSuccess: payload => ({
        type: TYPES.CHECK_EMAIL_VERIFICATION_SUCCESS,
        payload
    }),

    checkEmailVerificationFailed: error => ({
        type: TYPES.CHECK_EMAIL_VERIFICATION_FAILED,
        payload: {error}
    }),

    logoutEvent: () => ({
        type: TYPES.LOGOUT
    })
};
